function prevent(_target, _propertyKey, descriptor) {
  const next = descriptor.value;

  Object.assign(descriptor, {
    value(event: Event) {
      event instanceof Event && event.stopPropagation();
      return Reflect.apply(next, this, arguments);
    },
  });
}

export default prevent;
